import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5 3h18a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-3v7a1 1 0 1 1-2 0v-7H6v7a1 1 0 1 1-2 0v-7H1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM2.586 5H2v.586zM2 8.414V11h2.134q.064-.112.159-.207L10.086 5H5.414zM12.914 5l-6 6h4.672l6-6zm7.5 0-6 6h4.172L22 7.586V5zM22 10.414l-.586.586H22z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }